import React from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons";
import Logo from "../../assets/hafnia-logo.png";

const STEPS = [
  { label: "Account Information", path: "account" },
  { label: "Bank Details",        path: "bank" },
  { label: "Files",               path: "files" },
  { label: "Review & Submit",     path: "review" },
];

export const Header = () => {
  const { pathname } = useLocation();
  const segment = pathname.split("/").pop();
  const currentStep = STEPS.findIndex((s) => s.path === segment);

  return (
    <div className="bg-white border-bottom box-shadow mb-3">
      <div className="vf-header-row p-3 px-md-4">
        <div>
          <img height="30" src={Logo} alt="" />
        </div>
        {currentStep !== -1 && (
          <div className="vf-stepper vf-stepper--inline">
            {STEPS.map((step, index) => {
            const done = index < currentStep;
            const active = index === currentStep;
            const state = done ? "done" : active ? "active" : "pending";
            return (
              <React.Fragment key={step.path}>
                <div className={`vf-stepper__item vf-stepper__item--${state}`}>
                  {done
                    ? <FontAwesomeIcon icon={faCircleCheck} className="vf-stepper__icon" />
                    : <div className="vf-stepper__circle">{index + 1}</div>
                  }
                  <div className="vf-stepper__label">{step.label}</div>
                </div>
                {index < STEPS.length - 1 && (
                  <div className={`vf-stepper__connector${done ? " vf-stepper__connector--done" : ""}`} />
                )}
              </React.Fragment>
            );
          })}
          </div>
        )}
      </div>
    </div>
  );
};
